// extracted by mini-css-extract-plugin
var _1 = "ListDivider-moduledivider__dzJEy";
export { _1 as "divider" }
